import * as types from "./purchaseOrdersActionTypes";
import * as apiUrls from "./purchaseOrdersApiUrls";
import { checkUnreadNotifications } from "../notifications/actions";

// TODO: remove this and use BaseApi
import Cookies from "universal-cookie";
import fetchWithProgress from "../../utils/FetchWithProgress";

const cookies = new Cookies();

export function fetchPurchaseOrders(loadingCallback, withDraft = false) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2PurchaseOrders(withDraft), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => response.json())
    .then(json => {
      if(json instanceof Array) dispatch(receivePurchaseOrders(json));
      loadingCallback();
    })
    .catch(error => {
      loadingCallback();
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

// TODO: Refactor to use endpoints scoped under /v2/user/
export function submitPurchaseOrders(body, onProgress, successCallback) {
  return (dispatch) => {
    return fetchWithProgress(apiUrls.apiV2PurchaseOrders(),
      {
        method: "POST",
        headers: { "Authorization": cookies.get("jwtToken") },
        body: body,
      },
      onProgress
    )
    .then((data) => {
      const { id, purchase_order_document } = JSON.parse(data);
      const { purchase_order_attachments } = purchase_order_document

      const draftData = {
        id,
        purchase_order_document,
        purchase_order_attachments,
      };

      successCallback(draftData);
      return dispatch(receivePurchaseOrders(draftData));
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function updatePurchaseOrders(body) {
  return fetch(apiUrls.apiV2PurchaseOrders(), {
    method: "PUT",
    headers: new Headers({
      "Authorization": cookies.get("jwtToken"),
    }),
    body,
  })
}

export function updatePurchaseOrderWithProgress(id, userID, body, successCallback, onProgress, json = false) {
  var headers = {
    "Authorization": cookies.get("jwtToken"),
  }

  if(json) {
    headers = {
      "Authorization": cookies.get("jwtToken"),
      "Content-Type": "application/json",
    }
  }

  return (dispatch) => {
    return fetchWithProgress(apiUrls.apiV2PurchaseOrder(id, userID),
      {
        method: "PUT",
        headers: headers,
        body: body,
      },
      onProgress
    )
    .then((json) => {
      successCallback(JSON.parse(json));
    })
    .catch((error) => {
      console.error(error)
    })
  }
}

export function updatePurchaseOrder(id, userID, body, successCallback, json = false) {
  var headers = new Headers({
    "Authorization": cookies.get("jwtToken"),
  })

  if(json) {
    headers = new Headers({
      "Authorization": cookies.get("jwtToken"),
      "Content-Type": "application/json",
    })
  }

  return (dispatch) => {
    return fetch(apiUrls.apiV2PurchaseOrder(id, userID), {
      method: "PUT",
      headers: headers,
      body,
    })
    .then((response) => {
      if (response.ok) {
        response.json().then(json => {
          successCallback(json);
        })
      }
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  }
}

export function fetchPurchaseOrder(id, userId, onSuccess, onError) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2PurchaseOrder(id, userId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          if (!!json) {
            onSuccess(json);
            dispatch(receivePurchaseOrders(json));
          }
        });
      }
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function fetchPurchaseOrderAttachments(id, userId, successCallback) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2PurchaseOrderAttachments(id, userId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          successCallback(json);
        });
      }
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function fetchPurchaseOrderNotifications(id, userId, successCallback) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2PurchaseOrderNotifications(id, userId), {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          successCallback(json);
        });
      }
    })
    .catch(error => {
      dispatch({
        type: "HANDLE_ERRORS",
        payload: error,
      })
      dispatch({ type: "LOADING_STOP" });
    });
  };
}

export function resolvePurchaseOrderNotifications(body, id, userId, successCallback) {
  return (dispatch) => {
    return fetch(apiUrls.apiV2PurchaseOrderResolveNotifications(id, userId), {
      method: "PUT",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": cookies.get("jwtToken")
      }),
      body: JSON.stringify(body),
    })
    .then(response => {
      if (response.ok) {
        response.json().then(json => {
          dispatch(checkUnreadNotifications());
          successCallback(json);
        });
      }
    });
  };
}

export function receivePurchaseOrders(data) {
  return { type: types.RECEIVE_PURCHASE_ORDERS, payload: data };
}

export function createPurchaseOrders(data) {
  return { type: types.CREATE_PURCHASE_ORDERS, payload: data };
}

export function removePurchaseOrders() {
  return { type: types.REMOVE_PURCHASE_ORDERS, payload: [] }
}

export function filterPurchaseOrders(data) {
  return { type: types.FILTER_PURCHASE_ORDERS, payload: data }
}



// WEBPACK FOOTER //
// ./src/features/trade_documents/purchaseOrdersActions.js